<template>
  <main :class="style.contactInfo">
    <h2>Заполните форму ниже, наш администратор свяжется с вами</h2>
    <div :class="style.contact">
      <div>
        <span>Введите ваше ФИО</span>
        <input
          autocomplete="name"
          v-model="chose.ClientFullName"
          type="text"
          placeholder="Иванов Иван Иванович"
        />
      </div>
      <div>
        <span>Введите ваш телефон</span>
        <PreviousPhoneInput v-model="chose.ClientPhone" />
      </div>
      <div>
        <span>Комментарий</span>
        <textarea
          v-model="chose.comment"
          placeholder="Интересует удаление зуба мудрости"
        ></textarea>
      </div>
    </div>
    <button v-if="sendStaus == 'Loading'">
      <LoaderTextButton />
    </button>
    <button
      :class="style.notActive + ' ' + style.errorSend"
      v-else-if="sendStaus == 'Error'"
    >
      Ошибка
    </button>
    <button :class="style.notActive" v-else-if="!isPhoneMasked(chose)">
      Отправить
    </button>
    <button v-else @click="setChose('Заявка')">Отправить</button>
    <a target="_blank" href="https://readds.ru/policy"
      >Нажимая на кнопку, вы даёте согласие на обработку персональных данных и
      соглашаетесь с политикой конфиденциальности.</a
    >
  </main>
</template>
<script lang="ts">
import style from "../StyleWidget.module.scss";
import {defineComponent} from "vue";
import PreviousPhoneInput from "@/elements/phoneInput/PreviousPhoneInput.vue";
import {isPhoneMasked} from "../ScriptsWidget";
import LoaderTextButton from "@/elements/loaderTextButton/LoaderTextButton.vue";

export default defineComponent({
  name: "ConsultationForm",
  components: {PreviousPhoneInput, LoaderTextButton},
  data() {
    return {
      style,
      isPhoneMasked
    };
  },
  mounted() {
    document.addEventListener("keydown", this.keyboard);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.keyboard);
  },
  methods: {
    keyboard(e: KeyboardEvent) {
      if (this.chose.ClientPhone.length < 16 || e.code != "Enter") {
        return;
      }
      this.setChose("Запись");
    },
    setChose(name: string) {
      this.$widgetStore.setChose(name);
    }
  },
  computed: {
    sendStaus() {
      return this.$widgetStore.getSendStatus;
    },
    selectedMonthStr() {
      return this.$widgetStore.getSelectedMonthStr;
    },
    getClinic() {
      return this.$widgetStore.clinic;
    },
    chose() {
      return this.$widgetStore.getChose;
    }
  }
});
</script>
